import styled from 'styled-components'

export const NurseViewContainer = styled.div`
  display: flex;
  margin: 20px;
  flex-direction: column;
  @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 130px;
    margin-bottom: 20px;
    gap:15px;
  }
`
